import { SHELL_MAIN_PAGE_MANIFEST } from '@src/modules/shell-routing/domain/shellFeatureManifest.ts';

const shellPageModules = import.meta.glob('../../../core/bootstrap/shell/pages/**/*Component.ts');

function moduleKey(pageComponentPath: string): string {
  return `../../../core/bootstrap/shell/pages/${pageComponentPath}`;
}

const loadedPageIds = new Set<string>();
const inflightByPageId = new Map<string, Promise<void>>();

/** Side-effect import registers the Lit custom element for `pageId`. */
export async function ensureShellPageComponentLoaded(pageId: string): Promise<void> {
  if (loadedPageIds.has(pageId)) return;

  const entry = SHELL_MAIN_PAGE_MANIFEST.find((row) => row.pageId === pageId);
  if (!entry) throw new Error(`Unknown shell pageId: ${pageId}`);

  const key = moduleKey(entry.pageComponentPath);
  const load = shellPageModules[key];
  if (!load) throw new Error(`Shell page module not found: ${key}`);

  let pending = inflightByPageId.get(pageId);
  if (!pending) {
    pending = load().then(() => {
      loadedPageIds.add(pageId);
      inflightByPageId.delete(pageId);
    });
    inflightByPageId.set(pageId, pending);
  }
  await pending;
}

/** @internal architecture tests */
export function listShellLazyPageModuleKeys(): string[] {
  return SHELL_MAIN_PAGE_MANIFEST.map(({ pageComponentPath }) => moduleKey(pageComponentPath));
}

/** @internal architecture tests — every manifest page must resolve in the Vite glob map. */
export function findMissingShellLazyPageModules(): string[] {
  return listShellLazyPageModuleKeys().filter((key) => shellPageModules[key] == null);
}

/** @internal test hook */
export function resetShellLazyPageLoadForTests(): void {
  loadedPageIds.clear();
  inflightByPageId.clear();
}
